import React, { Component } from 'react';
import './categories.scss';
import SubCategoryItem from './sub-category-item';

interface CategoriesProp {
  categories: any[],
  parentCategory: any
}

class SubCategories extends Component<CategoriesProp> {
  render() {
    return (
      <div className={"categories-container" + (this.props.categories?.length > 0 ? " has-content" : "")}>
        {this.props.categories.map((category) => (
          <div className="category-wrap" key={category.id}>
            <SubCategoryItem parentCategory={this.props.parentCategory} item={category} />
          </div>
        ))}
      </div>
    );
  }
}

export default SubCategories;
